/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedTicketGame } from './ParsedTicketGame';
import {
    ParsedTicketGameFromJSON,
    ParsedTicketGameFromJSONTyped,
    ParsedTicketGameToJSON,
} from './ParsedTicketGame';

/**
 * The full set of ticket play data parsed out of the underlying scan's CGS payload. Customer-specific wallet plugins
 * are responsible for converting raw CGS shapes into this structure so PDS itself stays CGS-agnostic. A ticket scan
 * is always for a single game.
 * @export
 * @interface ParsedTicketData
 */
export interface ParsedTicketData {
    /**
     * 
     * @type {ParsedTicketGame}
     * @memberof ParsedTicketData
     */
    game: ParsedTicketGame;
}

/**
 * Check if a given object implements the ParsedTicketData interface.
 */
export function instanceOfParsedTicketData(value: object): value is ParsedTicketData {
    if (!('game' in value) || value['game'] === undefined) return false;
    return true;
}

export function ParsedTicketDataFromJSON(json: any): ParsedTicketData {
    return ParsedTicketDataFromJSONTyped(json, false);
}

export function ParsedTicketDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedTicketData {
    if (json == null) {
        return json;
    }
    return {
        
        'game': ParsedTicketGameFromJSON(json['game']),
    };
}

export function ParsedTicketDataToJSON(value?: ParsedTicketData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'game': ParsedTicketGameToJSON(value['game']),
    };
}

